import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "device-management" }
const _hoisted_2 = { class: "hero-banner" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-icon" }
const _hoisted_5 = { class: "hero-actions" }
const _hoisted_6 = { class: "stats-row" }
const _hoisted_7 = { class: "stat-icon-wrap" }
const _hoisted_8 = { class: "stat-info" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "stat-label" }
const _hoisted_11 = { class: "stat-trend" }
const _hoisted_12 = { class: "search-section" }
const _hoisted_13 = { class: "search-input-wrapper" }
const _hoisted_14 = { class: "search-info" }
const _hoisted_15 = { class: "batch-list" }
const _hoisted_16 = { class: "batch-header" }
const _hoisted_17 = { class: "batch-left" }
const _hoisted_18 = { class: "batch-icon" }
const _hoisted_19 = { class: "batch-meta" }
const _hoisted_20 = { class: "batch-title" }
const _hoisted_21 = { class: "batch-code" }
const _hoisted_22 = {
  key: 0,
  class: "batch-time"
}
const _hoisted_23 = { class: "batch-stats" }
const _hoisted_24 = { class: "batch-stat-item stat-active" }
const _hoisted_25 = {
  key: 0,
  class: "batch-stat-item stat-disabled"
}
const _hoisted_26 = { class: "batch-stat-item stat-total" }
const _hoisted_27 = { class: "batch-actions" }
const _hoisted_28 = { class: "device-list" }
const _hoisted_29 = { class: "device-cell cell-id" }
const _hoisted_30 = { class: "device-id-text" }
const _hoisted_31 = { class: "device-cell cell-name" }
const _hoisted_32 = { class: "device-cell cell-channel" }
const _hoisted_33 = { class: "channel-badge" }
const _hoisted_34 = { class: "device-cell cell-status" }
const _hoisted_35 = { class: "device-cell cell-actions" }
const _hoisted_36 = { class: "action-row action-row-main" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "action-row action-row-sub" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["disabled", "title", "onClick"]

import { ref, computed, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  Monitor,
  Plus,
  Search,
  DocumentChecked,
  Download,
  CircleCheck,
  Clock,
  CircleClose,
  VideoPause,
  VideoPlay,
  Refresh,
  RefreshRight,
  Delete,
  Switch,
  Box,
} from "@element-plus/icons-vue";
import {
  getAllDevicesApi,
  deleteDeviceApi,
  toggleEndpointStatusApi,
  downloadCertBatchPackageApi,
  type DeviceItem,
} from "@/api/cert/certBatchApi";
import PreRegisterDevicesDialog from "./PreRegisterDevicesDialog.vue";
import ReplaceHardwareDialog from "./ReplaceHardwareDialog.vue";
import ChangeChannelDialog from "./ChangeChannelDialog.vue";
import MigrateDeviceProtocolsDialog from "./MigrateDeviceProtocolsDialog.vue";

interface BatchGroup {
  batchId: string;
  batchCode: string;
  devices: DeviceItem[];
  activatedCount: number;
  disabledCount: number;
  batchCreateTime: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CertBatchManagementView',
  setup(__props) {

const loading = ref(false);
const deviceList = ref<DeviceItem[]>([]);
const searchKeyword = ref("");

const statsList = computed(() => {
  const total = deviceList.value.length;
  const active = deviceList.value.filter(
    (d) => d.activated && d.enabled !== 0
  ).length;
  const disabled = deviceList.value.filter(
    (d) => d.activated && d.enabled === 0
  ).length;
  const max = Math.max(total, 1);
  return [
    {
      label: "总录入",
      value: total,
      color: "#3b82f6",
      icon: "Monitor",
      cls: "stat-blue",
      barWidth: `${(total / max) * 100}%`,
    },
    {
      label: "在线",
      value: active,
      color: "#10b981",
      icon: "CircleCheck",
      cls: "stat-green",
      barWidth: `${(active / max) * 100}%`,
    },
    {
      label: "已禁用",
      value: disabled,
      color: "#ef4444",
      icon: "CircleClose",
      cls: "stat-red",
      barWidth: `${(disabled / max) * 100}%`,
    },
  ];
});

const filteredBatches = computed<BatchGroup[]>(() => {
  let list = deviceList.value;
  if (searchKeyword.value) {
    const kw = searchKeyword.value.toLowerCase();
    list = list.filter(
      (d) =>
        (d.deviceId && d.deviceId.toLowerCase().includes(kw)) ||
        (d.name && d.name.toLowerCase().includes(kw))
    );
  }

  const map = new Map<string, BatchGroup>();
  for (const d of list) {
    const bid = d.certBatchId || "unknown";
    if (!map.has(bid)) {
      map.set(bid, {
        batchId: bid,
        batchCode: d.batchCode || "未知批次",
        devices: [],
        activatedCount: 0,
        disabledCount: 0,
        batchCreateTime: d.batchCreateTime || null,
      });
    }
    const batch = map.get(bid)!;
    batch.devices.push(d);
    if (d.enabled === 0) batch.disabledCount++;
    else batch.activatedCount++;
  }

  // 按证书批次创建时间倒序排列（最新的在最上面）
  return Array.from(map.values()).sort((a, b) => {
    const ta = a.batchCreateTime ? new Date(a.batchCreateTime).getTime() : 0;
    const tb = b.batchCreateTime ? new Date(b.batchCreateTime).getTime() : 0;
    return tb - ta;
  });
});

const getStatusText = (row: DeviceItem) => {
  if (row.enabled === 0) return "已禁用";
  return "已激活";
};

const getStatusClass = (row: DeviceItem) => {
  if (row.enabled === 0) return "pill-red";
  return "pill-emerald";
};

const loadDevices = async () => {
  loading.value = true;
  const result = await getAllDevicesApi();
  loading.value = false;
  if (result) {
    deviceList.value = result;
  }
};

const toggleDevice = async (row: DeviceItem) => {
  try {
    const result = await toggleEndpointStatusApi(row.endpointId);
    if (result) {
      ElMessage.success(`终端已${result.action}`);
      await loadDevices();
    }
  } catch (e: any) {
    ElMessage.error(e.message || "操作失败");
  }
};

const deleteDevice = async (row: DeviceItem) => {
  try {
    await ElMessageBox.confirm(
      `确认删除已禁用设备 ${row.deviceId}？`,
      "删除设备",
      { type: "warning" }
    );
    const result = await deleteDeviceApi(row.endpointId);
    if (result) {
      ElMessage.success("设备已删除");
      await loadDevices();
    }
  } catch (e: any) {
    if (e !== "cancel") ElMessage.error(e.message || "删除失败");
  }
};

const downloadCert = async (batchId: string, batchCode: string) => {
  try {
    await downloadCertBatchPackageApi(batchId, `${batchCode}-certs.zip`);
    ElMessage.success("证书压缩包下载成功");
  } catch (e) {
    ElMessage.error("证书下载失败");
  }
};

const preRegisterVisible = ref(false);
const preRegisterBatchId = ref("");
const preRegisterBatchCode = ref("");
const replaceHardwareVisible = ref(false);
const replaceHardwareEndpointId = ref("");
const replaceHardwareDeviceId = ref("");
const replaceHardwareName = ref("");

const changeChannelVisible = ref(false);
const changeChannelEndpointId = ref("");
const changeChannelCurrentChannel = ref(1);
const changeChannelDeviceId = ref("");

const openChangeChannel = (row: DeviceItem) => {
  changeChannelEndpointId.value = row.endpointId;
  changeChannelCurrentChannel.value = row.channel || 1;
  changeChannelDeviceId.value = row.deviceId || "";
  changeChannelVisible.value = true;
};

/** 顶部入口：新建批次录入——必须清空残留的批次信息，否则会误入"追加设备"模式
 *  （场景：先点过批次里的"添加设备"再关掉，batchId 残留导致顶部按钮也变成追加弹窗） */
const openPreRegister = () => {
  preRegisterBatchId.value = "";
  preRegisterBatchCode.value = "";
  preRegisterVisible.value = true;
};

const openAddDevices = (batch: { batchId: string; batchCode: string }) => {
  preRegisterBatchId.value = batch.batchId;
  preRegisterBatchCode.value = batch.batchCode;
  preRegisterVisible.value = true;
};

const openReplaceHardware = (row: DeviceItem) => {
  replaceHardwareEndpointId.value = row.endpointId;
  replaceHardwareDeviceId.value = row.deviceId || "";
  replaceHardwareName.value = row.name || "";
  replaceHardwareVisible.value = true;
};

// 迁移设备协议（换硬件配套）
const migrateVisible = ref(false);
const migrateEndpointId = ref("");
const migrateDeviceId = ref("");
const migrateShipId = ref("");
const migrateShipName = ref("");

const openMigrate = (row: DeviceItem) => {
  if (!row.shipId) return;
  migrateEndpointId.value = row.endpointId;
  migrateDeviceId.value = row.deviceId || "";
  migrateShipId.value = row.shipId;
  migrateShipName.value = row.shipName || "";
  migrateVisible.value = true;
};

const formatTime = (time: string) => {
  if (!time) return "";
  const d = new Date(time);
  return d.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatBatchTime = (time: string) => {
  if (!time) return "";
  const d = new Date(time);
  return `创建于 ${d.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })}`;
};

onMounted(() => {
  loadDevices();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-bg" }, [
        _createElementVNode("div", { class: "hero-orb hero-orb-1" }),
        _createElementVNode("div", { class: "hero-orb hero-orb-2" }),
        _createElementVNode("div", { class: "hero-orb hero-orb-3" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, {
            size: 28,
            color: "#fff"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Monitor))
            ]),
            _: 1
          })
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-text" }, [
          _createElementVNode("h1", { class: "hero-title" }, "终端设备管理"),
          _createElementVNode("p", { class: "hero-subtitle" }, " 管理设备硬件编号 · 控制终端接入 · 监控激活状态 ")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            class: "hero-btn hero-btn-refresh",
            size: "large",
            loading: loading.value,
            onClick: loadDevices
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Refresh))
                ]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "刷新", -1))
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            class: "hero-btn",
            size: "large",
            onClick: openPreRegister
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Plus))
                ]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "录入终端设备", -1))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statsList.value, (stat, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["stat-card", stat.cls]),
          style: _normalizeStyle({ animationDelay: i * 0.1 + 's' })
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-glow" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_icon, {
              size: 22,
              color: stat.color
            }, {
              default: _withCtx(() => [
                (stat.icon === 'Monitor')
                  ? (_openBlock(), _createBlock(_unref(Monitor), { key: 0 }))
                  : (stat.icon === 'CircleCheck')
                    ? (_openBlock(), _createBlock(_unref(CircleCheck), { key: 1 }))
                    : (stat.icon === 'Clock')
                      ? (_openBlock(), _createBlock(_unref(Clock), { key: 2 }))
                      : (stat.icon === 'CircleClose')
                        ? (_openBlock(), _createBlock(_unref(CircleClose), { key: 3 }))
                        : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(stat.value), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(stat.label), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "stat-bar",
              style: _normalizeStyle({ width: stat.barWidth })
            }, null, 4)
          ])
        ], 6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_input, {
          modelValue: searchKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
          placeholder: "输入 deviceId 或名称搜索...",
          clearable: "",
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[10] || (_cache[10] = _createTextVNode(" 共 ", -1)),
        _createElementVNode("strong", null, _toDisplayString(filteredBatches.value.reduce((s, b) => s + b.devices.length, 0)), 1),
        _cache[11] || (_cache[11] = _createTextVNode(" 台终端 · ", -1)),
        _createElementVNode("strong", null, _toDisplayString(filteredBatches.value.length), 1),
        _cache[12] || (_cache[12] = _createTextVNode(" 个证书批次 ", -1))
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
      (!loading.value && filteredBatches.value.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无终端设备",
            class: "empty-state"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: openPreRegister
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("立即录入", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBatches.value, (batch, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: batch.batchId,
          class: "batch-card",
          style: _normalizeStyle({ animationDelay: idx * 0.08 + 's' })
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_icon, {
                  size: 18,
                  color: "#fff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DocumentChecked))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "batch-prefix" }, "证书", -1)),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(batch.batchCode), 1),
                  (batch.batchCreateTime)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createVNode(_component_el_icon, { size: 13 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Clock))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(formatBatchTime(batch.batchCreateTime)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, "已激活 " + _toDisplayString(batch.activatedCount), 1),
                  (batch.disabledCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "已禁用 " + _toDisplayString(batch.disabledCount), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_26, "共 " + _toDisplayString(batch.devices.length) + " 台", 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_button, {
                class: "add-device-btn",
                size: "default",
                plain: "",
                onClick: ($event: any) => (openAddDevices(batch))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "添加设备", -1))
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "download-btn",
                size: "default",
                onClick: ($event: any) => (downloadCert(batch.batchId, batch.batchCode))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Download))
                    ]),
                    _: 1
                  }),
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "下载证书", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"device-row device-row-head\" data-v-e36650dc><div class=\"device-cell cell-id\" data-v-e36650dc><span class=\"head-label\" data-v-e36650dc>终端编号 deviceId</span></div><div class=\"device-cell cell-name\" data-v-e36650dc><span class=\"head-label\" data-v-e36650dc>终端名称</span></div><div class=\"device-cell cell-channel\" data-v-e36650dc><span class=\"head-label\" data-v-e36650dc>频道</span></div><div class=\"device-cell cell-status\" data-v-e36650dc><span class=\"head-label\" data-v-e36650dc>状态</span></div><div class=\"device-cell cell-actions\" data-v-e36650dc><span class=\"head-label\" data-v-e36650dc>操作</span></div></div>", 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(batch.devices, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.endpointId,
                class: _normalizeClass(["device-row", {
              'is-disabled': row.enabled === 0,
            }])
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "device-id-dot" }, null, -1)),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(row.deviceId), 1)
                ]),
                _createElementVNode("div", _hoisted_31, _toDisplayString(row.name || "—"), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, "频道" + _toDisplayString(row.channel || 1), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-pill", getStatusClass(row)])
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "pulse" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(getStatusText(row)), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    (row.enabled !== 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "action-pill pill-danger",
                          onClick: ($event: any) => (toggleDevice(row))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(VideoPause))
                            ]),
                            _: 1
                          }),
                          _cache[19] || (_cache[19] = _createTextVNode("禁用 ", -1))
                        ], 8, _hoisted_37))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            class: "action-pill pill-success",
                            onClick: ($event: any) => (toggleDevice(row))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(VideoPlay))
                              ]),
                              _: 1
                            }),
                            _cache[20] || (_cache[20] = _createTextVNode("启用 ", -1))
                          ], 8, _hoisted_38),
                          _createElementVNode("button", {
                            class: "action-pill pill-danger",
                            onClick: ($event: any) => (deleteDevice(row))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Delete))
                              ]),
                              _: 1
                            }),
                            _cache[21] || (_cache[21] = _createTextVNode("删除 ", -1))
                          ], 8, _hoisted_39)
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("button", {
                      class: "action-pill pill-amber",
                      onClick: ($event: any) => (openReplaceHardware(row))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(RefreshRight))
                        ]),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createTextVNode("换硬件 ", -1))
                    ], 8, _hoisted_41),
                    _createElementVNode("button", {
                      class: "action-pill pill-blue",
                      onClick: ($event: any) => (openChangeChannel(row))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Switch))
                        ]),
                        _: 1
                      }),
                      _cache[23] || (_cache[23] = _createTextVNode("换频道 ", -1))
                    ], 8, _hoisted_42),
                    (row.shipId)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["action-pill pill-green", { 'pill-disabled': row.status !== 'ONLINE' }]),
                          disabled: row.status !== 'ONLINE',
                          title: 
                    row.status !== 'ONLINE'
                      ? '终端离线，新终端上线后可迁移设备协议'
                      : '将船舶设备协议文件迁移到该终端'
                  ,
                          onClick: ($event: any) => (openMigrate(row))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Box))
                            ]),
                            _: 1
                          }),
                          _cache[24] || (_cache[24] = _createTextVNode("迁移设备 ", -1))
                        ], 10, _hoisted_43))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ], 4))
      }), 128))
    ])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(PreRegisterDevicesDialog, {
      modelValue: preRegisterVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((preRegisterVisible).value = $event)),
      "cert-batch-id": preRegisterBatchId.value,
      "batch-code": preRegisterBatchCode.value,
      onSuccess: loadDevices
    }, null, 8, ["modelValue", "cert-batch-id", "batch-code"]),
    _createVNode(ReplaceHardwareDialog, {
      modelValue: replaceHardwareVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((replaceHardwareVisible).value = $event)),
      "endpoint-id": replaceHardwareEndpointId.value,
      "current-device-id": replaceHardwareDeviceId.value,
      "current-name": replaceHardwareName.value,
      onSuccess: loadDevices
    }, null, 8, ["modelValue", "endpoint-id", "current-device-id", "current-name"]),
    _createVNode(ChangeChannelDialog, {
      modelValue: changeChannelVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((changeChannelVisible).value = $event)),
      "endpoint-id": changeChannelEndpointId.value,
      "current-channel": changeChannelCurrentChannel.value,
      "device-id": changeChannelDeviceId.value,
      onSuccess: loadDevices
    }, null, 8, ["modelValue", "endpoint-id", "current-channel", "device-id"]),
    _createVNode(MigrateDeviceProtocolsDialog, {
      modelValue: migrateVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((migrateVisible).value = $event)),
      "endpoint-id": migrateEndpointId.value,
      "device-id": migrateDeviceId.value,
      "ship-id": migrateShipId.value,
      "ship-name": migrateShipName.value
    }, null, 8, ["modelValue", "endpoint-id", "device-id", "ship-id", "ship-name"])
  ]))
}
}

})